!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("react-dom")) : "function" == typeof define && define.amd ? define("ReactDropdownTreeSelect", ["react", "react-dom"], t) : "object" == typeof exports ? exports.ReactDropdownTreeSelect = t(require("react"), require("react-dom")) : e.ReactDropdownTreeSelect = t(e.React, e.ReactDOM);
}(this, function (e, t) {
  return function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;
      var o = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }

    var n = {};
    return t.m = e, t.c = n, t.d = function (e, n, r) {
      t.o(e, n) || Object.defineProperty(e, n, {
        configurable: !1,
        enumerable: !0,
        get: r
      });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 49);
  }([function (e, t, n) {
    var r = n(33),
        o = "object" == typeof self && self && self.Object === Object && self,
        i = r || o || Function("return this")();
    e.exports = i;
  }, function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    (function (t) {
      if ("production" !== t.env.NODE_ENV) {
        var r = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103,
            o = function o(e) {
          return "object" == typeof e && null !== e && e.$$typeof === r;
        };

        e.exports = n(50)(o, !0);
      } else e.exports = n(52)();
    }).call(t, n(5));
  }, function (e, t, n) {
    function r(e, t) {
      var n = i(e, t);
      return o(n) ? n : void 0;
    }

    var o = n(61),
        i = n(67);
    e.exports = r;
  }, function (e, t) {
    function n(e) {
      var t = typeof e;
      return null != e && ("object" == t || "function" == t);
    }

    e.exports = n;
  }, function (e, t) {
    function n() {
      throw new Error("setTimeout has not been defined");
    }

    function r() {
      throw new Error("clearTimeout has not been defined");
    }

    function o(e) {
      if (f === setTimeout) return setTimeout(e, 0);
      if ((f === n || !f) && setTimeout) return f = setTimeout, setTimeout(e, 0);

      try {
        return f(e, 0);
      } catch (t) {
        try {
          return f.call(null, e, 0);
        } catch (t) {
          return f.call(this, e, 0);
        }
      }
    }

    function i(e) {
      if (l === clearTimeout) return clearTimeout(e);
      if ((l === r || !l) && clearTimeout) return l = clearTimeout, clearTimeout(e);

      try {
        return l(e);
      } catch (t) {
        try {
          return l.call(null, e);
        } catch (t) {
          return l.call(this, e);
        }
      }
    }

    function a() {
      y && d && (y = !1, d.length ? h = d.concat(h) : v = -1, h.length && c());
    }

    function c() {
      if (!y) {
        var e = o(a);
        y = !0;

        for (var t = h.length; t;) {
          for (d = h, h = []; ++v < t;) {
            d && d[v].run();
          }

          v = -1, t = h.length;
        }

        d = null, y = !1, i(e);
      }
    }

    function u(e, t) {
      this.fun = e, this.array = t;
    }

    function s() {}

    var f,
        l,
        p = e.exports = {};
    !function () {
      try {
        f = "function" == typeof setTimeout ? setTimeout : n;
      } catch (e) {
        f = n;
      }

      try {
        l = "function" == typeof clearTimeout ? clearTimeout : r;
      } catch (e) {
        l = r;
      }
    }();
    var d,
        h = [],
        y = !1,
        v = -1;
    p.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        t[n - 1] = arguments[n];
      }
      h.push(new u(e, t)), 1 !== h.length || y || o(c);
    }, u.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, p.title = "browser", p.browser = !0, p.env = {}, p.argv = [], p.version = "", p.versions = {}, p.on = s, p.addListener = s, p.once = s, p.off = s, p.removeListener = s, p.removeAllListeners = s, p.emit = s, p.prependListener = s, p.prependOnceListener = s, p.listeners = function (e) {
      return [];
    }, p.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, p.cwd = function () {
      return "/";
    }, p.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, p.umask = function () {
      return 0;
    };
  }, function (e, t, n) {
    function r(e) {
      return null == e ? void 0 === e ? u : c : s && s in Object(e) ? i(e) : a(e);
    }

    var o = n(18),
        i = n(63),
        a = n(64),
        c = "[object Null]",
        u = "[object Undefined]",
        s = o ? o.toStringTag : void 0;
    e.exports = r;
  }, function (e, t, n) {
    var r, o;
    /*!
    Copyright (c) 2016 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
    */

    !function () {
      "use strict";

      function n() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var r = arguments[t];

          if (r) {
            var o = typeof r;
            if ("string" === o || "number" === o) e.push(this && this[r] || r);else if (Array.isArray(r)) e.push(n.apply(this, r));else if ("object" === o) for (var a in r) {
              i.call(r, a) && r[a] && e.push(this && this[a] || a);
            }
          }
        }

        return e.join(" ");
      }

      var i = {}.hasOwnProperty;
      void 0 !== e && e.exports ? e.exports = n : (r = [], void 0 !== (o = function () {
        return n;
      }.apply(t, r)) && (e.exports = o));
    }();
  }, function (e, t) {
    function n(e) {
      var t = e && e.constructor;
      return e === ("function" == typeof t && t.prototype || r);
    }

    var r = Object.prototype;
    e.exports = n;
  }, function (e, t) {
    function n(e) {
      return null != e && "object" == typeof e;
    }

    e.exports = n;
  }, function (e, t) {
    var n = Array.isArray;
    e.exports = n;
  }, function (e, t, n) {
    function r(e) {
      var t = -1,
          n = null == e ? 0 : e.length;

      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }

    var o = n(79),
        i = n(80),
        a = n(81),
        c = n(82),
        u = n(83);
    r.prototype.clear = o, r.prototype.delete = i, r.prototype.get = a, r.prototype.has = c, r.prototype.set = u, e.exports = r;
  }, function (e, t, n) {
    function r(e, t) {
      for (var n = e.length; n--;) {
        if (o(e[n][0], t)) return n;
      }

      return -1;
    }

    var o = n(38);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(3),
        o = r(Object, "create");
    e.exports = o;
  }, function (e, t, n) {
    function r(e, t) {
      var n = e.__data__;
      return o(t) ? n["string" == typeof t ? "string" : "hash"] : n.map;
    }

    var o = n(98);
    e.exports = r;
  }, function (e, t, n) {
    function r(e, t, n, r) {
      var a = !n;
      n || (n = {});

      for (var c = -1, u = t.length; ++c < u;) {
        var s = t[c],
            f = r ? r(n[s], e[s], s, n, e) : void 0;
        void 0 === f && (f = e[s]), a ? i(n, s, f) : o(n, s, f);
      }

      return n;
    }

    var o = n(39),
        i = n(40);
    e.exports = r;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return function () {
        return e;
      };
    }

    var o = function o() {};

    o.thatReturns = r, o.thatReturnsFalse = r(!1), o.thatReturnsTrue = r(!0), o.thatReturnsNull = r(null), o.thatReturnsThis = function () {
      return this;
    }, o.thatReturnsArgument = function (e) {
      return e;
    }, e.exports = o;
  }, function (e, t, n) {
    "use strict";

    (function (t) {
      function n(e, t, n, o, i, a, c, u) {
        if (r(t), !e) {
          var s;
          if (void 0 === t) s = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
            var f = [n, o, i, a, c, u],
                l = 0;
            s = new Error(t.replace(/%s/g, function () {
              return f[l++];
            })), s.name = "Invariant Violation";
          }
          throw s.framesToPop = 1, s;
        }
      }

      var r = function r(e) {};

      "production" !== t.env.NODE_ENV && (r = function r(e) {
        if (void 0 === e) throw new Error("invariant requires an error message argument");
      }), e.exports = n;
    }).call(t, n(5));
  }, function (e, t, n) {
    var r = n(0),
        o = r.Symbol;
    e.exports = o;
  }, function (e, t, n) {
    var r = n(3),
        o = n(0),
        i = r(o, "Map");
    e.exports = i;
  }, function (e, t, n) {
    function r(e) {
      return null != e && i(e.length) && !o(e);
    }

    var o = n(32),
        i = n(36);
    e.exports = r;
  }, function (e, t, n) {
    (function (e) {
      var r = n(0),
          o = n(72),
          i = "object" == typeof t && t && !t.nodeType && t,
          a = i && "object" == typeof e && e && !e.nodeType && e,
          c = a && a.exports === i,
          u = c ? r.Buffer : void 0,
          s = u ? u.isBuffer : void 0,
          f = s || o;
      e.exports = f;
    }).call(t, n(22)(e));
  }, function (e, t) {
    e.exports = function (e) {
      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
        enumerable: !0,
        get: function get() {
          return e.l;
        }
      }), Object.defineProperty(e, "id", {
        enumerable: !0,
        get: function get() {
          return e.i;
        }
      }), e.webpackPolyfill = 1), e;
    };
  }, function (e, t, n) {
    function r(e) {
      return a(e) ? o(e) : i(e);
    }

    var o = n(41),
        i = n(29),
        a = n(20);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(113),
        o = n(43),
        i = Object.prototype,
        a = i.propertyIsEnumerable,
        c = Object.getOwnPropertySymbols,
        u = c ? function (e) {
      return null == e ? [] : (e = Object(e), r(c(e), function (t) {
        return a.call(e, t);
      }));
    } : o;
    e.exports = u;
  }, function (e, t, n) {
    function r(e) {
      var t = new e.constructor(e.byteLength);
      return new o(t).set(new o(e)), t;
    }

    var o = n(119);
    e.exports = r;
  }, function (e, t, n) {
    "use strict";

    (function (t) {
      var r = n(16),
          o = r;
      "production" !== t.env.NODE_ENV && function () {
        var e = function e(_e) {
          for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
            n[r - 1] = arguments[r];
          }

          var o = 0,
              i = "Warning: " + _e.replace(/%s/g, function () {
            return n[o++];
          });

          "undefined" != typeof console && console.error(i);

          try {
            throw new Error(i);
          } catch (e) {}
        };

        o = function o(t, n) {
          if (void 0 === n) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");

          if (0 !== n.indexOf("Failed Composite propType: ") && !t) {
            for (var r = arguments.length, o = Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++) {
              o[i - 2] = arguments[i];
            }

            e.apply(void 0, [n].concat(o));
          }
        };
      }(), e.exports = o;
    }).call(t, n(5));
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    function r(e) {
      if (null == e) return !0;
      if (u(e) && (c(e) || "string" == typeof e || "function" == typeof e.splice || s(e) || l(e) || a(e))) return !e.length;
      var t = i(e);
      if (t == p || t == d) return !e.size;
      if (f(e)) return !o(e).length;

      for (var n in e) {
        if (y.call(e, n)) return !1;
      }

      return !0;
    }

    var o = n(29),
        i = n(31),
        a = n(35),
        c = n(10),
        u = n(20),
        s = n(21),
        f = n(8),
        l = n(37),
        p = "[object Map]",
        d = "[object Set]",
        h = Object.prototype,
        y = h.hasOwnProperty;
    e.exports = r;
  }, function (e, t, n) {
    function r(e) {
      if (!o(e)) return i(e);
      var t = [];

      for (var n in Object(e)) {
        c.call(e, n) && "constructor" != n && t.push(n);
      }

      return t;
    }

    var o = n(8),
        i = n(59),
        a = Object.prototype,
        c = a.hasOwnProperty;
    e.exports = r;
  }, function (e, t) {
    function n(e, t) {
      return function (n) {
        return e(t(n));
      };
    }

    e.exports = n;
  }, function (e, t, n) {
    var r = n(60),
        o = n(19),
        i = n(68),
        a = n(69),
        c = n(70),
        u = n(6),
        s = n(34),
        f = s(r),
        l = s(o),
        p = s(i),
        d = s(a),
        h = s(c),
        y = u;
    (r && "[object DataView]" != y(new r(new ArrayBuffer(1))) || o && "[object Map]" != y(new o()) || i && "[object Promise]" != y(i.resolve()) || a && "[object Set]" != y(new a()) || c && "[object WeakMap]" != y(new c())) && (y = function y(e) {
      var t = u(e),
          n = "[object Object]" == t ? e.constructor : void 0,
          r = n ? s(n) : "";
      if (r) switch (r) {
        case f:
          return "[object DataView]";

        case l:
          return "[object Map]";

        case p:
          return "[object Promise]";

        case d:
          return "[object Set]";

        case h:
          return "[object WeakMap]";
      }
      return t;
    }), e.exports = y;
  }, function (e, t, n) {
    function r(e) {
      if (!i(e)) return !1;
      var t = o(e);
      return t == c || t == u || t == a || t == s;
    }

    var o = n(6),
        i = n(4),
        a = "[object AsyncFunction]",
        c = "[object Function]",
        u = "[object GeneratorFunction]",
        s = "[object Proxy]";
    e.exports = r;
  }, function (e, t, n) {
    (function (t) {
      var n = "object" == typeof t && t && t.Object === Object && t;
      e.exports = n;
    }).call(t, n(62));
  }, function (e, t) {
    function n(e) {
      if (null != e) {
        try {
          return o.call(e);
        } catch (e) {}

        try {
          return e + "";
        } catch (e) {}
      }

      return "";
    }

    var r = Function.prototype,
        o = r.toString;
    e.exports = n;
  }, function (e, t, n) {
    var r = n(71),
        o = n(9),
        i = Object.prototype,
        a = i.hasOwnProperty,
        c = i.propertyIsEnumerable,
        u = r(function () {
      return arguments;
    }()) ? r : function (e) {
      return o(e) && a.call(e, "callee") && !c.call(e, "callee");
    };
    e.exports = u;
  }, function (e, t) {
    function n(e) {
      return "number" == typeof e && e > -1 && e % 1 == 0 && e <= r;
    }

    var r = 9007199254740991;
    e.exports = n;
  }, function (e, t, n) {
    var r = n(73),
        o = n(74),
        i = n(75),
        a = i && i.isTypedArray,
        c = a ? o(a) : r;
    e.exports = c;
  }, function (e, t) {
    function n(e, t) {
      return e === t || e !== e && t !== t;
    }

    e.exports = n;
  }, function (e, t, n) {
    function r(e, t, n) {
      var r = e[t];
      c.call(e, t) && i(r, n) && (void 0 !== n || t in e) || o(e, t, n);
    }

    var o = n(40),
        i = n(38),
        a = Object.prototype,
        c = a.hasOwnProperty;
    e.exports = r;
  }, function (e, t, n) {
    function r(e, t, n) {
      "__proto__" == t && o ? o(e, t, {
        configurable: !0,
        enumerable: !0,
        value: n,
        writable: !0
      }) : e[t] = n;
    }

    var o = n(103);
    e.exports = r;
  }, function (e, t, n) {
    function r(e, t) {
      var n = a(e),
          r = !n && i(e),
          f = !n && !r && c(e),
          p = !n && !r && !f && s(e),
          d = n || r || f || p,
          h = d ? o(e.length, String) : [],
          y = h.length;

      for (var v in e) {
        !t && !l.call(e, v) || d && ("length" == v || f && ("offset" == v || "parent" == v) || p && ("buffer" == v || "byteLength" == v || "byteOffset" == v) || u(v, y)) || h.push(v);
      }

      return h;
    }

    var o = n(105),
        i = n(35),
        a = n(10),
        c = n(21),
        u = n(106),
        s = n(37),
        f = Object.prototype,
        l = f.hasOwnProperty;
    e.exports = r;
  }, function (e, t, n) {
    function r(e) {
      return a(e) ? o(e, !0) : i(e);
    }

    var o = n(41),
        i = n(108),
        a = n(20);
    e.exports = r;
  }, function (e, t) {
    function n() {
      return [];
    }

    e.exports = n;
  }, function (e, t, n) {
    var r = n(45),
        o = n(46),
        i = n(24),
        a = n(43),
        c = Object.getOwnPropertySymbols,
        u = c ? function (e) {
      for (var t = []; e;) {
        r(t, i(e)), e = o(e);
      }

      return t;
    } : a;
    e.exports = u;
  }, function (e, t) {
    function n(e, t) {
      for (var n = -1, r = t.length, o = e.length; ++n < r;) {
        e[o + n] = t[n];
      }

      return e;
    }

    e.exports = n;
  }, function (e, t, n) {
    var r = n(30),
        o = r(Object.getPrototypeOf, Object);
    e.exports = o;
  }, function (e, t, n) {
    function r(e, t, n) {
      var r = t(e);
      return i(e) ? r : o(r, n(e));
    }

    var o = n(45),
        i = n(10);
    e.exports = r;
  }, function (e, t) {
    function n(e, t, n, r) {
      var o = -1,
          i = null == e ? 0 : e.length;

      for (r && i && (n = e[++o]); ++o < i;) {
        n = t(n, e[o], o, e);
      }

      return n;
    }

    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        c = n.n(a),
        u = n(2),
        s = n.n(u),
        f = n(7),
        l = n.n(f),
        p = n(53),
        d = n.n(p),
        h = n(58),
        y = n(133),
        v = n(137),
        b = n(145),
        g = n.n(b),
        m = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        _ = l.a.bind(g.a),
        w = function (e) {
      function t(e) {
        r(this, t);
        var n = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
        return n.resetSearch = function () {
          n.setState({
            tree: n.treeManager.restoreNodes(),
            searchModeOn: !1,
            allNodesHidden: !1
          }), n.searchInput.value = "";
        }, n.onAction = function (e, t) {
          "function" == typeof n.props.onAction && n.props.onAction(e, n.treeManager.getNodeById(t));
        }, n.state = {
          dropdownActive: n.props.showDropdown || !1,
          searchModeOn: !1
        }, n.onInputChange = n.onInputChange.bind(n), n.onDrowdownHide = n.onDrowdownHide.bind(n), n.onCheckboxChange = n.onCheckboxChange.bind(n), n.notifyChange = n.notifyChange.bind(n), n.onTagRemove = n.onTagRemove.bind(n), n.onNodeToggle = n.onNodeToggle.bind(n), n;
      }

      return i(t, e), m(t, [{
        key: "notifyChange",
        value: function value() {
          var e;
          "function" == typeof this.props.onChange && (e = this.props).onChange.apply(e, arguments);
        }
      }, {
        key: "createList",
        value: function value(e) {
          return this.treeManager = new h.a(e), this.treeManager.tree;
        }
      }, {
        key: "componentWillMount",
        value: function value() {
          var e = this.createList(this.props.data),
              t = this.treeManager.getTags();
          this.setState({
            tree: e,
            tags: t
          });
        }
      }, {
        key: "componentWillReceiveProps",
        value: function value(e) {
          var t = this.createList(e.data),
              n = this.treeManager.getTags();
          this.setState({
            tree: t,
            tags: n
          });
        }
      }, {
        key: "onDrowdownHide",
        value: function value() {
          this.keepDropdownActive ? this.dropdown.show() : this.resetSearch();
        }
      }, {
        key: "onInputChange",
        value: function value(e) {
          var t = this.treeManager.filterTree(e),
              n = t.allNodesHidden,
              r = t.tree,
              o = e.length > 0;
          this.setState({
            tree: r,
            searchModeOn: o,
            allNodesHidden: n
          });
        }
      }, {
        key: "onTagRemove",
        value: function value(e) {
          this.onCheckboxChange(e, !1);
        }
      }, {
        key: "onNodeToggle",
        value: function value(e) {
          this.treeManager.toggleNodeExpandState(e), this.setState({
            tree: this.treeManager.tree
          }), "function" == typeof this.props.onNodeToggle && this.props.onNodeToggle(this.treeManager.getNodeById(e));
        }
      }, {
        key: "onCheckboxChange",
        value: function value(e, t) {
          this.treeManager.setNodeCheckedState(e, t);
          var n = this.treeManager.getTags();
          this.setState({
            tree: this.treeManager.tree,
            tags: n
          }), this.notifyChange(this.treeManager.getNodeById(e), n);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this;
          return c.a.createElement("div", {
            className: l()(this.props.className, "react-dropdown-tree-select")
          }, c.a.createElement(d.a, {
            ref: function ref(t) {
              e.dropdown = t;
            },
            onHide: this.onDrowdownHide
          }, c.a.createElement(p.DropdownTrigger, {
            className: _("dropdown-trigger")
          }, c.a.createElement(v.a, {
            inputRef: function inputRef(t) {
              e.searchInput = t;
            },
            tags: this.state.tags,
            placeholderText: this.props.placeholderText,
            onInputChange: this.onInputChange,
            onFocus: function onFocus() {
              e.keepDropdownActive = !0;
            },
            onBlur: function onBlur() {
              e.keepDropdownActive = !1;
            },
            onTagRemove: this.onTagRemove
          })), c.a.createElement(p.DropdownContent, {
            className: _("dropdown-content")
          }, this.state.allNodesHidden ? c.a.createElement("span", {
            className: "no-matches"
          }, "No matches found") : c.a.createElement(y.a, {
            data: this.state.tree,
            searchModeOn: this.state.searchModeOn,
            onAction: this.onAction,
            onCheckboxChange: this.onCheckboxChange,
            onNodeToggle: this.onNodeToggle
          }))));
        }
      }]), t;
    }(a.Component);

    w.propTypes = {
      data: s.a.oneOfType([s.a.object, s.a.array]).isRequired,
      placeholderText: s.a.string,
      showDropdown: s.a.bool,
      className: s.a.string,
      onChange: s.a.func,
      onAction: s.a.func,
      onNodeToggle: s.a.func
    }, t.default = w;
  }, function (e, t, n) {
    "use strict";

    (function (t) {
      var r = n(16),
          o = n(17),
          i = n(26),
          a = n(27),
          c = n(51);

      e.exports = function (e, n) {
        function u(e) {
          var t = e && (O && e[O] || e[k]);
          if ("function" == typeof t) return t;
        }

        function s(e, t) {
          return e === t ? 0 !== e || 1 / e == 1 / t : e !== e && t !== t;
        }

        function f(e) {
          this.message = e, this.stack = "";
        }

        function l(e) {
          function r(r, s, l, p, d, h, y) {
            if (p = p || T, h = h || l, y !== a) if (n) o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");else if ("production" !== t.env.NODE_ENV && "undefined" != typeof console) {
              var v = p + ":" + l;
              !c[v] && u < 3 && (i(!1, "You are manually calling a React.PropTypes validation function for the `%s` prop on `%s`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.", h, p), c[v] = !0, u++);
            }
            return null == s[l] ? r ? new f(null === s[l] ? "The " + d + " `" + h + "` is marked as required in `" + p + "`, but its value is `null`." : "The " + d + " `" + h + "` is marked as required in `" + p + "`, but its value is `undefined`.") : null : e(s, l, p, d, h);
          }

          if ("production" !== t.env.NODE_ENV) var c = {},
              u = 0;
          var s = r.bind(null, !1);
          return s.isRequired = r.bind(null, !0), s;
        }

        function p(e) {
          function t(t, n, r, o, i, a) {
            var c = t[n];
            if (w(c) !== e) return new f("Invalid " + o + " `" + i + "` of type `" + j(c) + "` supplied to `" + r + "`, expected `" + e + "`.");
            return null;
          }

          return l(t);
        }

        function d(e) {
          function t(t, n, r, o, i) {
            if ("function" != typeof e) return new f("Property `" + i + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
            var c = t[n];

            if (!Array.isArray(c)) {
              return new f("Invalid " + o + " `" + i + "` of type `" + w(c) + "` supplied to `" + r + "`, expected an array.");
            }

            for (var u = 0; u < c.length; u++) {
              var s = e(c, u, r, o, i + "[" + u + "]", a);
              if (s instanceof Error) return s;
            }

            return null;
          }

          return l(t);
        }

        function h(e) {
          function t(t, n, r, o, i) {
            if (!(t[n] instanceof e)) {
              var a = e.name || T;
              return new f("Invalid " + o + " `" + i + "` of type `" + x(t[n]) + "` supplied to `" + r + "`, expected instance of `" + a + "`.");
            }

            return null;
          }

          return l(t);
        }

        function y(e) {
          function n(t, n, r, o, i) {
            for (var a = t[n], c = 0; c < e.length; c++) {
              if (s(a, e[c])) return null;
            }

            return new f("Invalid " + o + " `" + i + "` of value `" + a + "` supplied to `" + r + "`, expected one of " + JSON.stringify(e) + ".");
          }

          return Array.isArray(e) ? l(n) : ("production" !== t.env.NODE_ENV && i(!1, "Invalid argument supplied to oneOf, expected an instance of array."), r.thatReturnsNull);
        }

        function v(e) {
          function t(t, n, r, o, i) {
            if ("function" != typeof e) return new f("Property `" + i + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
            var c = t[n],
                u = w(c);
            if ("object" !== u) return new f("Invalid " + o + " `" + i + "` of type `" + u + "` supplied to `" + r + "`, expected an object.");

            for (var s in c) {
              if (c.hasOwnProperty(s)) {
                var l = e(c, s, r, o, i + "." + s, a);
                if (l instanceof Error) return l;
              }
            }

            return null;
          }

          return l(t);
        }

        function b(e) {
          function n(t, n, r, o, i) {
            for (var c = 0; c < e.length; c++) {
              if (null == (0, e[c])(t, n, r, o, i, a)) return null;
            }

            return new f("Invalid " + o + " `" + i + "` supplied to `" + r + "`.");
          }

          return Array.isArray(e) ? l(n) : ("production" !== t.env.NODE_ENV && i(!1, "Invalid argument supplied to oneOfType, expected an instance of array."), r.thatReturnsNull);
        }

        function g(e) {
          function t(t, n, r, o, i) {
            var c = t[n],
                u = w(c);
            if ("object" !== u) return new f("Invalid " + o + " `" + i + "` of type `" + u + "` supplied to `" + r + "`, expected `object`.");

            for (var s in e) {
              var l = e[s];

              if (l) {
                var p = l(c, s, r, o, i + "." + s, a);
                if (p) return p;
              }
            }

            return null;
          }

          return l(t);
        }

        function m(t) {
          switch (typeof t) {
            case "number":
            case "string":
            case "undefined":
              return !0;

            case "boolean":
              return !t;

            case "object":
              if (Array.isArray(t)) return t.every(m);
              if (null === t || e(t)) return !0;
              var n = u(t);
              if (!n) return !1;
              var r,
                  o = n.call(t);

              if (n !== t.entries) {
                for (; !(r = o.next()).done;) {
                  if (!m(r.value)) return !1;
                }
              } else for (; !(r = o.next()).done;) {
                var i = r.value;
                if (i && !m(i[1])) return !1;
              }

              return !0;

            default:
              return !1;
          }
        }

        function _(e, t) {
          return "symbol" === e || "Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol;
        }

        function w(e) {
          var t = typeof e;
          return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : _(t, e) ? "symbol" : t;
        }

        function j(e) {
          var t = w(e);

          if ("object" === t) {
            if (e instanceof Date) return "date";
            if (e instanceof RegExp) return "regexp";
          }

          return t;
        }

        function x(e) {
          return e.constructor && e.constructor.name ? e.constructor.name : T;
        }

        var O = "function" == typeof Symbol && Symbol.iterator,
            k = "@@iterator",
            T = "<<anonymous>>",
            E = {
          array: p("array"),
          bool: p("boolean"),
          func: p("function"),
          number: p("number"),
          object: p("object"),
          string: p("string"),
          symbol: p("symbol"),
          any: function () {
            return l(r.thatReturnsNull);
          }(),
          arrayOf: d,
          element: function () {
            function t(t, n, r, o, i) {
              var a = t[n];

              if (!e(a)) {
                return new f("Invalid " + o + " `" + i + "` of type `" + w(a) + "` supplied to `" + r + "`, expected a single ReactElement.");
              }

              return null;
            }

            return l(t);
          }(),
          instanceOf: h,
          node: function () {
            function e(e, t, n, r, o) {
              return m(e[t]) ? null : new f("Invalid " + r + " `" + o + "` supplied to `" + n + "`, expected a ReactNode.");
            }

            return l(e);
          }(),
          objectOf: v,
          oneOf: y,
          oneOfType: b,
          shape: g
        };
        return f.prototype = Error.prototype, E.checkPropTypes = c, E.PropTypes = E, E;
      };
    }).call(t, n(5));
  }, function (e, t, n) {
    "use strict";

    (function (t) {
      function r(e, n, r, u, s) {
        if ("production" !== t.env.NODE_ENV) for (var f in e) {
          if (e.hasOwnProperty(f)) {
            var l;

            try {
              o("function" == typeof e[f], "%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.", u || "React class", r, f), l = e[f](n, f, u, r, null, a);
            } catch (e) {
              l = e;
            }

            if (i(!l || l instanceof Error, "%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", u || "React class", r, f, typeof l), l instanceof Error && !(l.message in c)) {
              c[l.message] = !0;
              var p = s ? s() : "";
              i(!1, "Failed %s type: %s%s", r, l.message, null != p ? p : "");
            }
          }
        }
      }

      if ("production" !== t.env.NODE_ENV) var o = n(17),
          i = n(26),
          a = n(27),
          c = {};
      e.exports = r;
    }).call(t, n(5));
  }, function (e, t, n) {
    "use strict";

    var r = n(16),
        o = n(17);

    e.exports = function () {
      function e() {
        o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t
      };
      return n.checkPropTypes = r, n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function o(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DropdownContent = t.DropdownTrigger = void 0;

    var c = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        u = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        s = n(1),
        f = r(s),
        l = n(2),
        p = r(l),
        d = n(54),
        h = n(55),
        y = r(h),
        v = n(56),
        b = r(v),
        g = n(57),
        m = r(g),
        _ = function (e) {
      function t(e) {
        o(this, t);
        var n = i(this, Object.getPrototypeOf(t).call(this, e));
        return n.state = {
          active: !1
        }, n._onWindowClick = n._onWindowClick.bind(n), n._onToggleClick = n._onToggleClick.bind(n), n;
      }

      return a(t, e), u(t, [{
        key: "componentDidMount",
        value: function value() {
          window.addEventListener("click", this._onWindowClick), window.addEventListener("touchstart", this._onWindowClick);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          window.removeEventListener("click", this._onWindowClick), window.removeEventListener("touchstart", this._onWindowClick);
        }
      }]), u(t, [{
        key: "isActive",
        value: function value() {
          return "boolean" == typeof this.props.active ? this.props.active : this.state.active;
        }
      }, {
        key: "hide",
        value: function value() {
          var e = this;
          this.setState({
            active: !1
          }, function () {
            e.props.onHide && e.props.onHide();
          });
        }
      }, {
        key: "show",
        value: function value() {
          var e = this;
          this.setState({
            active: !0
          }, function () {
            e.props.onShow && e.props.onShow();
          });
        }
      }, {
        key: "_onWindowClick",
        value: function value(e) {
          var t = (0, d.findDOMNode)(this);
          e.target !== t && !t.contains(e.target) && this.isActive() && this.hide();
        }
      }, {
        key: "_onToggleClick",
        value: function value(e) {
          e.preventDefault(), this.isActive() ? this.hide() : this.show();
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
              t = arguments,
              n = this.props,
              r = n.children,
              o = n.className,
              i = n.disabled,
              a = n.removeElement,
              u = this.isActive(),
              l = (0, y.default)({
            dropdown: !0,
            "dropdown--active": u,
            "dropdown--disabled": i
          }),
              p = f.default.Children.map(r, function (n) {
            return n.type === b.default ? function () {
              var r = n.props.onClick;
              n = (0, s.cloneElement)(n, {
                ref: "trigger",
                onClick: function onClick(o) {
                  i || (e._onToggleClick(o), r && r.apply(n, t));
                }
              });
            }() : n.type === m.default && a && !u && (n = null), n;
          }),
              d = c({}, this.props);
          return delete d.active, delete d.onShow, delete d.onHide, delete d.removeElement, f.default.createElement("div", c({}, d, {
            className: l + " " + o
          }), p);
        }
      }]), t;
    }(s.Component);

    _.propTypes = {
      disabled: p.default.bool,
      active: p.default.bool,
      onHide: p.default.func,
      onShow: p.default.func,
      children: p.default.node,
      className: p.default.string,
      removeElement: p.default.bool,
      style: p.default.object
    }, _.defaultProps = {
      className: ""
    }, t.DropdownTrigger = b.default, t.DropdownContent = m.default, t.default = _;
  }, function (e, n) {
    e.exports = t;
  }, function (e, t, n) {
    var r, o;
    /*!
    Copyright (c) 2016 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
    */

    !function () {
      "use strict";

      function n() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var r = arguments[t];

          if (r) {
            var o = typeof r;
            if ("string" === o || "number" === o) e.push(r);else if (Array.isArray(r)) e.push(n.apply(null, r));else if ("object" === o) for (var a in r) {
              i.call(r, a) && r[a] && e.push(a);
            }
          }
        }

        return e.join(" ");
      }

      var i = {}.hasOwnProperty;
      void 0 !== e && e.exports ? e.exports = n : (r = [], void 0 !== (o = function () {
        return n;
      }.apply(t, r)) && (e.exports = o));
    }();
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function o(e, t) {
      var n = {};

      for (var r in e) {
        t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
      }

      return n;
    }

    function i(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function a(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function c(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var u = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        s = n(1),
        f = r(s),
        l = n(2),
        p = r(l),
        d = function (e) {
      function t() {
        return i(this, t), a(this, Object.getPrototypeOf(t).apply(this, arguments));
      }

      return c(t, e), u(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.children,
              n = e.className,
              r = o(e, ["children", "className"]);
          return r.className = "dropdown__trigger " + n, f.default.createElement("a", r, t);
        }
      }]), t;
    }(s.Component);

    d.displayName = "DropdownTrigger", d.propTypes = {
      children: p.default.node,
      className: p.default.string
    }, d.defaultProps = {
      className: ""
    }, t.default = d;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function o(e, t) {
      var n = {};

      for (var r in e) {
        t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
      }

      return n;
    }

    function i(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function a(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function c(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var u = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        s = n(1),
        f = r(s),
        l = n(2),
        p = r(l),
        d = function (e) {
      function t() {
        return i(this, t), a(this, Object.getPrototypeOf(t).apply(this, arguments));
      }

      return c(t, e), u(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.children,
              n = e.className,
              r = o(e, ["children", "className"]);
          return r.className = "dropdown__content " + n, f.default.createElement("div", r, t);
        }
      }]), t;
    }(s.Component);

    d.displayName = "DropdownContent", d.propTypes = {
      children: p.default.node,
      className: p.default.string
    }, d.defaultProps = {
      className: ""
    }, t.default = d;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    var o = n(28),
        i = n.n(o),
        a = n(76),
        c = n.n(a),
        u = n(132),
        s = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        f = function () {
      function e(t) {
        var n = this;
        r(this, e), this._src = t, this.tree = Object(u.a)(c()(t)), this.tree.forEach(function (e) {
          n.setInitialCheckState(e);
        }), this.searchMaps = new Map();
      }

      return s(e, [{
        key: "getNodeById",
        value: function value(e) {
          return this.tree.get(e);
        }
      }, {
        key: "getMatches",
        value: function value(e) {
          var t = this;
          if (this.searchMaps.has(e)) return this.searchMaps.get(e);
          var n = -1,
              r = e;
          this.searchMaps.forEach(function (t, o) {
            e.startsWith(o) && o.length > n && (n = o.length, r = o);
          });
          var o = [];

          if (r !== e) {
            this.searchMaps.get(r).forEach(function (n) {
              var r = t.getNodeById(n);
              r.label.toLowerCase().indexOf(e) >= 0 && o.push(r._id);
            });
          } else this.tree.forEach(function (t) {
            t.label.toLowerCase().indexOf(e) >= 0 && o.push(t._id);
          });

          return this.searchMaps.set(e, o), o;
        }
      }, {
        key: "filterTree",
        value: function value(e) {
          var t = this,
              n = this.getMatches(e.toLowerCase());
          return this.tree.forEach(function (e) {
            e.hide = !0;
          }), n.forEach(function (e) {
            t.getNodeById(e).hide = !1;
          }), {
            allNodesHidden: 0 === n.length,
            tree: this.tree
          };
        }
      }, {
        key: "restoreNodes",
        value: function value() {
          return this.tree.forEach(function (e) {
            e.hide = !1;
          }), this.tree;
        }
      }, {
        key: "setInitialCheckState",
        value: function value(e) {
          void 0 === e.checked && (e.checked = this.getNodeCheckedState(e));
        }
      }, {
        key: "getNodeCheckedState",
        value: function value(e) {
          for (var t = !1, n = e._parent; n && !t;) {
            var r = this.getNodeById(n);
            t = r.checked || !1, n = r._parent;
          }

          return t;
        }
      }, {
        key: "setNodeCheckedState",
        value: function value(e, t) {
          var n = this.getNodeById(e);
          n.checked = t, this.toggleChildren(e, t), t || this.unCheckParents(n);
        }
      }, {
        key: "unCheckParents",
        value: function value(e) {
          for (var t = e._parent; t;) {
            var n = this.getNodeById(t);
            n.checked = !1, t = n._parent;
          }
        }
      }, {
        key: "toggleChildren",
        value: function value(e, t) {
          var n = this,
              r = this.getNodeById(e);
          r.checked = t, i()(r._children) || r._children.forEach(function (e) {
            return n.toggleChildren(e, t);
          });
        }
      }, {
        key: "toggleNodeExpandState",
        value: function value(e) {
          var t = this.getNodeById(e);
          return t.expanded = !t.expanded, t.expanded || this.collapseChildren(t), this.tree;
        }
      }, {
        key: "collapseChildren",
        value: function value(e) {
          var t = this;
          e.expanded = !1, i()(e._children) || e._children.forEach(function (e) {
            return t.collapseChildren(t.getNodeById(e));
          });
        }
      }, {
        key: "getTags",
        value: function value() {
          var e = this,
              t = [],
              n = {},
              r = function t(r) {
            n[r._id] = !0, i()(r._children) || r._children.forEach(function (n) {
              return t(e.getNodeById(n));
            });
          };

          return this.tree.forEach(function (e, o) {
            n[o] || (e.checked ? (t.push(e), r(e)) : n[o] = !0);
          }), t;
        }
      }]), e;
    }();

    t.a = f;
  }, function (e, t, n) {
    var r = n(30),
        o = r(Object.keys, Object);
    e.exports = o;
  }, function (e, t, n) {
    var r = n(3),
        o = n(0),
        i = r(o, "DataView");
    e.exports = i;
  }, function (e, t, n) {
    function r(e) {
      return !(!a(e) || i(e)) && (o(e) ? h : s).test(c(e));
    }

    var o = n(32),
        i = n(65),
        a = n(4),
        c = n(34),
        u = /[\\^$.*+?()[\]{}|]/g,
        s = /^\[object .+?Constructor\]$/,
        f = Function.prototype,
        l = Object.prototype,
        p = f.toString,
        d = l.hasOwnProperty,
        h = RegExp("^" + p.call(d).replace(u, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    e.exports = r;
  }, function (e, t) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || Function("return this")() || (0, eval)("this");
    } catch (e) {
      "object" == typeof window && (n = window);
    }

    e.exports = n;
  }, function (e, t, n) {
    function r(e) {
      var t = a.call(e, u),
          n = e[u];

      try {
        e[u] = void 0;
        var r = !0;
      } catch (e) {}

      var o = c.call(e);
      return r && (t ? e[u] = n : delete e[u]), o;
    }

    var o = n(18),
        i = Object.prototype,
        a = i.hasOwnProperty,
        c = i.toString,
        u = o ? o.toStringTag : void 0;
    e.exports = r;
  }, function (e, t) {
    function n(e) {
      return o.call(e);
    }

    var r = Object.prototype,
        o = r.toString;
    e.exports = n;
  }, function (e, t, n) {
    function r(e) {
      return !!i && i in e;
    }

    var o = n(66),
        i = function () {
      var e = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "");
      return e ? "Symbol(src)_1." + e : "";
    }();

    e.exports = r;
  }, function (e, t, n) {
    var r = n(0),
        o = r["__core-js_shared__"];
    e.exports = o;
  }, function (e, t) {
    function n(e, t) {
      return null == e ? void 0 : e[t];
    }

    e.exports = n;
  }, function (e, t, n) {
    var r = n(3),
        o = n(0),
        i = r(o, "Promise");
    e.exports = i;
  }, function (e, t, n) {
    var r = n(3),
        o = n(0),
        i = r(o, "Set");
    e.exports = i;
  }, function (e, t, n) {
    var r = n(3),
        o = n(0),
        i = r(o, "WeakMap");
    e.exports = i;
  }, function (e, t, n) {
    function r(e) {
      return i(e) && o(e) == a;
    }

    var o = n(6),
        i = n(9),
        a = "[object Arguments]";
    e.exports = r;
  }, function (e, t) {
    function n() {
      return !1;
    }

    e.exports = n;
  }, function (e, t, n) {
    function r(e) {
      return a(e) && i(e.length) && !!c[o(e)];
    }

    var o = n(6),
        i = n(36),
        a = n(9),
        c = {};
    c["[object Float32Array]"] = c["[object Float64Array]"] = c["[object Int8Array]"] = c["[object Int16Array]"] = c["[object Int32Array]"] = c["[object Uint8Array]"] = c["[object Uint8ClampedArray]"] = c["[object Uint16Array]"] = c["[object Uint32Array]"] = !0, c["[object Arguments]"] = c["[object Array]"] = c["[object ArrayBuffer]"] = c["[object Boolean]"] = c["[object DataView]"] = c["[object Date]"] = c["[object Error]"] = c["[object Function]"] = c["[object Map]"] = c["[object Number]"] = c["[object Object]"] = c["[object RegExp]"] = c["[object Set]"] = c["[object String]"] = c["[object WeakMap]"] = !1, e.exports = r;
  }, function (e, t) {
    function n(e) {
      return function (t) {
        return e(t);
      };
    }

    e.exports = n;
  }, function (e, t, n) {
    (function (e) {
      var r = n(33),
          o = "object" == typeof t && t && !t.nodeType && t,
          i = o && "object" == typeof e && e && !e.nodeType && e,
          a = i && i.exports === o,
          c = a && r.process,
          u = function () {
        try {
          return c && c.binding && c.binding("util");
        } catch (e) {}
      }();

      e.exports = u;
    }).call(t, n(22)(e));
  }, function (e, t, n) {
    function r(e) {
      return o(e, i | a);
    }

    var o = n(77),
        i = 1,
        a = 4;
    e.exports = r;
  }, function (e, t, n) {
    function r(e, t, n, A, S, R) {
      var M,
          I = t & x,
          D = t & O,
          B = t & k;
      if (n && (M = S ? n(e, A, S, R) : n(e)), void 0 !== M) return M;
      if (!w(e)) return e;
      var F = m(e);

      if (F) {
        if (M = v(e), !I) return f(e, M);
      } else {
        var z = y(e),
            L = z == E || z == C;
        if (_(e)) return s(e, I);

        if (z == N || z == T || L && !S) {
          if (M = D || L ? {} : g(e), !I) return D ? p(e, u(M, e)) : l(e, c(M, e));
        } else {
          if (!P[z]) return S ? e : {};
          M = b(e, z, r, I);
        }
      }

      R || (R = new o());
      var W = R.get(e);
      if (W) return W;
      R.set(e, M);
      var U = B ? D ? h : d : D ? keysIn : j,
          q = F ? void 0 : U(e);
      return i(q || e, function (o, i) {
        q && (i = o, o = e[i]), a(M, i, r(o, t, n, i, e, R));
      }), M;
    }

    var o = n(78),
        i = n(102),
        a = n(39),
        c = n(104),
        u = n(107),
        s = n(110),
        f = n(111),
        l = n(112),
        p = n(114),
        d = n(115),
        h = n(116),
        y = n(31),
        v = n(117),
        b = n(118),
        g = n(130),
        m = n(10),
        _ = n(21),
        w = n(4),
        j = n(23),
        x = 1,
        O = 2,
        k = 4,
        T = "[object Arguments]",
        E = "[object Function]",
        C = "[object GeneratorFunction]",
        N = "[object Object]",
        P = {};

    P[T] = P["[object Array]"] = P["[object ArrayBuffer]"] = P["[object DataView]"] = P["[object Boolean]"] = P["[object Date]"] = P["[object Float32Array]"] = P["[object Float64Array]"] = P["[object Int8Array]"] = P["[object Int16Array]"] = P["[object Int32Array]"] = P["[object Map]"] = P["[object Number]"] = P[N] = P["[object RegExp]"] = P["[object Set]"] = P["[object String]"] = P["[object Symbol]"] = P["[object Uint8Array]"] = P["[object Uint8ClampedArray]"] = P["[object Uint16Array]"] = P["[object Uint32Array]"] = !0, P["[object Error]"] = P[E] = P["[object WeakMap]"] = !1, e.exports = r;
  }, function (e, t, n) {
    function r(e) {
      var t = this.__data__ = new o(e);
      this.size = t.size;
    }

    var o = n(11),
        i = n(84),
        a = n(85),
        c = n(86),
        u = n(87),
        s = n(88);
    r.prototype.clear = i, r.prototype.delete = a, r.prototype.get = c, r.prototype.has = u, r.prototype.set = s, e.exports = r;
  }, function (e, t) {
    function n() {
      this.__data__ = [], this.size = 0;
    }

    e.exports = n;
  }, function (e, t, n) {
    function r(e) {
      var t = this.__data__,
          n = o(t, e);
      return !(n < 0) && (n == t.length - 1 ? t.pop() : a.call(t, n, 1), --this.size, !0);
    }

    var o = n(12),
        i = Array.prototype,
        a = i.splice;
    e.exports = r;
  }, function (e, t, n) {
    function r(e) {
      var t = this.__data__,
          n = o(t, e);
      return n < 0 ? void 0 : t[n][1];
    }

    var o = n(12);
    e.exports = r;
  }, function (e, t, n) {
    function r(e) {
      return o(this.__data__, e) > -1;
    }

    var o = n(12);
    e.exports = r;
  }, function (e, t, n) {
    function r(e, t) {
      var n = this.__data__,
          r = o(n, e);
      return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
    }

    var o = n(12);
    e.exports = r;
  }, function (e, t, n) {
    function r() {
      this.__data__ = new o(), this.size = 0;
    }

    var o = n(11);
    e.exports = r;
  }, function (e, t) {
    function n(e) {
      var t = this.__data__,
          n = t.delete(e);
      return this.size = t.size, n;
    }

    e.exports = n;
  }, function (e, t) {
    function n(e) {
      return this.__data__.get(e);
    }

    e.exports = n;
  }, function (e, t) {
    function n(e) {
      return this.__data__.has(e);
    }

    e.exports = n;
  }, function (e, t, n) {
    function r(e, t) {
      var n = this.__data__;

      if (n instanceof o) {
        var r = n.__data__;
        if (!i || r.length < c - 1) return r.push([e, t]), this.size = ++n.size, this;
        n = this.__data__ = new a(r);
      }

      return n.set(e, t), this.size = n.size, this;
    }

    var o = n(11),
        i = n(19),
        a = n(89),
        c = 200;
    e.exports = r;
  }, function (e, t, n) {
    function r(e) {
      var t = -1,
          n = null == e ? 0 : e.length;

      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }

    var o = n(90),
        i = n(97),
        a = n(99),
        c = n(100),
        u = n(101);
    r.prototype.clear = o, r.prototype.delete = i, r.prototype.get = a, r.prototype.has = c, r.prototype.set = u, e.exports = r;
  }, function (e, t, n) {
    function r() {
      this.size = 0, this.__data__ = {
        hash: new o(),
        map: new (a || i)(),
        string: new o()
      };
    }

    var o = n(91),
        i = n(11),
        a = n(19);
    e.exports = r;
  }, function (e, t, n) {
    function r(e) {
      var t = -1,
          n = null == e ? 0 : e.length;

      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }

    var o = n(92),
        i = n(93),
        a = n(94),
        c = n(95),
        u = n(96);
    r.prototype.clear = o, r.prototype.delete = i, r.prototype.get = a, r.prototype.has = c, r.prototype.set = u, e.exports = r;
  }, function (e, t, n) {
    function r() {
      this.__data__ = o ? o(null) : {}, this.size = 0;
    }

    var o = n(13);
    e.exports = r;
  }, function (e, t) {
    function n(e) {
      var t = this.has(e) && delete this.__data__[e];
      return this.size -= t ? 1 : 0, t;
    }

    e.exports = n;
  }, function (e, t, n) {
    function r(e) {
      var t = this.__data__;

      if (o) {
        var n = t[e];
        return n === i ? void 0 : n;
      }

      return c.call(t, e) ? t[e] : void 0;
    }

    var o = n(13),
        i = "__lodash_hash_undefined__",
        a = Object.prototype,
        c = a.hasOwnProperty;
    e.exports = r;
  }, function (e, t, n) {
    function r(e) {
      var t = this.__data__;
      return o ? void 0 !== t[e] : a.call(t, e);
    }

    var o = n(13),
        i = Object.prototype,
        a = i.hasOwnProperty;
    e.exports = r;
  }, function (e, t, n) {
    function r(e, t) {
      var n = this.__data__;
      return this.size += this.has(e) ? 0 : 1, n[e] = o && void 0 === t ? i : t, this;
    }

    var o = n(13),
        i = "__lodash_hash_undefined__";
    e.exports = r;
  }, function (e, t, n) {
    function r(e) {
      var t = o(this, e).delete(e);
      return this.size -= t ? 1 : 0, t;
    }

    var o = n(14);
    e.exports = r;
  }, function (e, t) {
    function n(e) {
      var t = typeof e;
      return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
    }

    e.exports = n;
  }, function (e, t, n) {
    function r(e) {
      return o(this, e).get(e);
    }

    var o = n(14);
    e.exports = r;
  }, function (e, t, n) {
    function r(e) {
      return o(this, e).has(e);
    }

    var o = n(14);
    e.exports = r;
  }, function (e, t, n) {
    function r(e, t) {
      var n = o(this, e),
          r = n.size;
      return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
    }

    var o = n(14);
    e.exports = r;
  }, function (e, t) {
    function n(e, t) {
      for (var n = -1, r = null == e ? 0 : e.length; ++n < r && !1 !== t(e[n], n, e);) {
        ;
      }

      return e;
    }

    e.exports = n;
  }, function (e, t, n) {
    var r = n(3),
        o = function () {
      try {
        var e = r(Object, "defineProperty");
        return e({}, "", {}), e;
      } catch (e) {}
    }();

    e.exports = o;
  }, function (e, t, n) {
    function r(e, t) {
      return e && o(t, i(t), e);
    }

    var o = n(15),
        i = n(23);
    e.exports = r;
  }, function (e, t) {
    function n(e, t) {
      for (var n = -1, r = Array(e); ++n < e;) {
        r[n] = t(n);
      }

      return r;
    }

    e.exports = n;
  }, function (e, t) {
    function n(e, t) {
      return !!(t = null == t ? r : t) && ("number" == typeof e || o.test(e)) && e > -1 && e % 1 == 0 && e < t;
    }

    var r = 9007199254740991,
        o = /^(?:0|[1-9]\d*)$/;
    e.exports = n;
  }, function (e, t, n) {
    function r(e, t) {
      return e && o(t, i(t), e);
    }

    var o = n(15),
        i = n(42);
    e.exports = r;
  }, function (e, t, n) {
    function r(e) {
      if (!o(e)) return a(e);
      var t = i(e),
          n = [];

      for (var r in e) {
        ("constructor" != r || !t && u.call(e, r)) && n.push(r);
      }

      return n;
    }

    var o = n(4),
        i = n(8),
        a = n(109),
        c = Object.prototype,
        u = c.hasOwnProperty;
    e.exports = r;
  }, function (e, t) {
    function n(e) {
      var t = [];
      if (null != e) for (var n in Object(e)) {
        t.push(n);
      }
      return t;
    }

    e.exports = n;
  }, function (e, t, n) {
    (function (e) {
      function r(e, t) {
        if (t) return e.slice();
        var n = e.length,
            r = s ? s(n) : new e.constructor(n);
        return e.copy(r), r;
      }

      var o = n(0),
          i = "object" == typeof t && t && !t.nodeType && t,
          a = i && "object" == typeof e && e && !e.nodeType && e,
          c = a && a.exports === i,
          u = c ? o.Buffer : void 0,
          s = u ? u.allocUnsafe : void 0;
      e.exports = r;
    }).call(t, n(22)(e));
  }, function (e, t) {
    function n(e, t) {
      var n = -1,
          r = e.length;

      for (t || (t = Array(r)); ++n < r;) {
        t[n] = e[n];
      }

      return t;
    }

    e.exports = n;
  }, function (e, t, n) {
    function r(e, t) {
      return o(e, i(e), t);
    }

    var o = n(15),
        i = n(24);
    e.exports = r;
  }, function (e, t) {
    function n(e, t) {
      for (var n = -1, r = null == e ? 0 : e.length, o = 0, i = []; ++n < r;) {
        var a = e[n];
        t(a, n, e) && (i[o++] = a);
      }

      return i;
    }

    e.exports = n;
  }, function (e, t, n) {
    function r(e, t) {
      return o(e, i(e), t);
    }

    var o = n(15),
        i = n(44);
    e.exports = r;
  }, function (e, t, n) {
    function r(e) {
      return o(e, a, i);
    }

    var o = n(47),
        i = n(24),
        a = n(23);
    e.exports = r;
  }, function (e, t, n) {
    function r(e) {
      return o(e, a, i);
    }

    var o = n(47),
        i = n(44),
        a = n(42);
    e.exports = r;
  }, function (e, t) {
    function n(e) {
      var t = e.length,
          n = e.constructor(t);
      return t && "string" == typeof e[0] && o.call(e, "index") && (n.index = e.index, n.input = e.input), n;
    }

    var r = Object.prototype,
        o = r.hasOwnProperty;
    e.exports = n;
  }, function (e, t, n) {
    function r(e, t, n, r) {
      var P = e.constructor;

      switch (t) {
        case m:
          return o(e);

        case l:
        case p:
          return new P(+e);

        case _:
          return i(e, r);

        case w:
        case j:
        case x:
        case O:
        case k:
        case T:
        case E:
        case C:
        case N:
          return f(e, r);

        case d:
          return a(e, r, n);

        case h:
        case b:
          return new P(e);

        case y:
          return c(e);

        case v:
          return u(e, r, n);

        case g:
          return s(e);
      }
    }

    var o = n(25),
        i = n(120),
        a = n(121),
        c = n(124),
        u = n(125),
        s = n(128),
        f = n(129),
        l = "[object Boolean]",
        p = "[object Date]",
        d = "[object Map]",
        h = "[object Number]",
        y = "[object RegExp]",
        v = "[object Set]",
        b = "[object String]",
        g = "[object Symbol]",
        m = "[object ArrayBuffer]",
        _ = "[object DataView]",
        w = "[object Float32Array]",
        j = "[object Float64Array]",
        x = "[object Int8Array]",
        O = "[object Int16Array]",
        k = "[object Int32Array]",
        T = "[object Uint8Array]",
        E = "[object Uint8ClampedArray]",
        C = "[object Uint16Array]",
        N = "[object Uint32Array]";
    e.exports = r;
  }, function (e, t, n) {
    var r = n(0),
        o = r.Uint8Array;
    e.exports = o;
  }, function (e, t, n) {
    function r(e, t) {
      var n = t ? o(e.buffer) : e.buffer;
      return new e.constructor(n, e.byteOffset, e.byteLength);
    }

    var o = n(25);
    e.exports = r;
  }, function (e, t, n) {
    function r(e, t, n) {
      var r = t ? n(a(e), c) : a(e);
      return i(r, o, new e.constructor());
    }

    var o = n(122),
        i = n(48),
        a = n(123),
        c = 1;
    e.exports = r;
  }, function (e, t) {
    function n(e, t) {
      return e.set(t[0], t[1]), e;
    }

    e.exports = n;
  }, function (e, t) {
    function n(e) {
      var t = -1,
          n = Array(e.size);
      return e.forEach(function (e, r) {
        n[++t] = [r, e];
      }), n;
    }

    e.exports = n;
  }, function (e, t) {
    function n(e) {
      var t = new e.constructor(e.source, r.exec(e));
      return t.lastIndex = e.lastIndex, t;
    }

    var r = /\w*$/;
    e.exports = n;
  }, function (e, t, n) {
    function r(e, t, n) {
      var r = t ? n(a(e), c) : a(e);
      return i(r, o, new e.constructor());
    }

    var o = n(126),
        i = n(48),
        a = n(127),
        c = 1;
    e.exports = r;
  }, function (e, t) {
    function n(e, t) {
      return e.add(t), e;
    }

    e.exports = n;
  }, function (e, t) {
    function n(e) {
      var t = -1,
          n = Array(e.size);
      return e.forEach(function (e) {
        n[++t] = e;
      }), n;
    }

    e.exports = n;
  }, function (e, t, n) {
    function r(e) {
      return a ? Object(a.call(e)) : {};
    }

    var o = n(18),
        i = o ? o.prototype : void 0,
        a = i ? i.valueOf : void 0;
    e.exports = r;
  }, function (e, t, n) {
    function r(e, t) {
      var n = t ? o(e.buffer) : e.buffer;
      return new e.constructor(n, e.byteOffset, e.length);
    }

    var o = n(25);
    e.exports = r;
  }, function (e, t, n) {
    function r(e) {
      return "function" != typeof e.constructor || a(e) ? {} : o(i(e));
    }

    var o = n(131),
        i = n(46),
        a = n(8);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(4),
        o = Object.create,
        i = function () {
      function e() {}

      return function (t) {
        if (!r(t)) return {};
        if (o) return o(t);
        e.prototype = t;
        var n = new e();
        return e.prototype = void 0, n;
      };
    }();

    e.exports = i;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return o({
        nodes: Array.isArray(e) ? e : [e]
      });
    }

    function o(e) {
      var t = e.nodes,
          n = e.list,
          r = void 0 === n ? new Map() : n,
          i = e.parent,
          a = e.depth,
          c = void 0 === a ? 0 : a;
      return t.forEach(function (e, t) {
        e._depth = c, i ? (e._id = e.id || i._id + "-" + t, e._parent = i._id, i._children.push(e._id)) : e._id = e.id || "" + t, r.set(e._id, e), e.children && (e._children = [], o({
          nodes: e.children,
          list: r,
          parent: e,
          depth: c + 1
        }), delete e.children);
      }), r;
    }

    t.a = r;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    var a = n(1),
        c = n.n(a),
        u = n(2),
        s = n.n(u),
        f = n(134),
        l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        p = function (e) {
      function t() {
        var e, n, i, a;
        r(this, t);

        for (var u = arguments.length, s = Array(u), l = 0; l < u; l++) {
          s[l] = arguments[l];
        }

        return n = i = o(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(s))), i.shouldRenderNode = function (e) {
          if (i.props.searchModeOn || e.expanded) return !0;
          var t = e._parent && i.props.data.get(e._parent);
          return !t || t.expanded;
        }, i.getNodes = function (e) {
          var t = i.props,
              n = t.onAction,
              r = t.onChange,
              o = t.onCheckboxChange,
              a = t.onNodeToggle,
              u = [];
          return e.forEach(function (e, t) {
            i.shouldRenderNode(e) && u.push(c.a.createElement(f.a, {
              key: t,
              node: e,
              onChange: r,
              onCheckboxChange: o,
              onNodeToggle: a,
              onAction: n
            }));
          }), u;
        }, a = n, o(i, a);
      }

      return i(t, e), l(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.data,
              n = e.searchModeOn;
          return c.a.createElement("ul", {
            className: "root " + (n ? "searchModeOn" : "")
          }, this.getNodes(t));
        }
      }]), t;
    }(a.Component);

    p.propTypes = {
      data: s.a.object,
      searchModeOn: s.a.bool,
      onChange: s.a.func,
      onNodeToggle: s.a.func,
      onAction: s.a.func,
      onCheckboxChange: s.a.func
    }, t.a = p;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    var a = n(1),
        c = n.n(a),
        u = n(2),
        s = n.n(u),
        f = n(28),
        l = n.n(f),
        p = n(135),
        d = n(7),
        h = n.n(d),
        y = n(136),
        v = n.n(y),
        b = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        g = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        m = h.a.bind(v.a),
        _ = function (e) {
      function t() {
        return r(this, t), o(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return i(t, e), g(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.node,
              n = e.onNodeToggle,
              r = e.onCheckboxChange,
              o = e.onAction,
              i = t.actions || [],
              a = l()(t._children),
              u = m("node", {
            leaf: a,
            tree: !a,
            hide: t.hide
          }, t.className),
              s = m("toggle", {
            expanded: !a && t.expanded,
            collapsed: !a && !t.expanded
          });
          return c.a.createElement("li", {
            className: u,
            style: {
              paddingLeft: 20 * t._depth + "px"
            }
          }, c.a.createElement("i", {
            className: s,
            onClick: function onClick() {
              return n(t._id);
            }
          }), c.a.createElement("label", {
            title: t.title || t.label
          }, c.a.createElement("input", {
            type: "checkbox",
            name: t._id,
            className: "checkbox-item",
            checked: t.checked,
            onChange: function onChange(e) {
              return r(t._id, e.target.checked);
            },
            value: t.value
          }), c.a.createElement("span", {
            className: "node-label"
          }, t.label)), i.map(function (e, n) {
            return c.a.createElement(p.a, b({
              key: "action-" + n
            }, e, {
              actionData: {
                action: e.id,
                node: t
              },
              onAction: o
            }));
          }));
        }
      }]), t;
    }(a.Component);

    _.propTypes = {
      node: s.a.shape({
        _id: s.a.string,
        _depth: s.a.number,
        _children: s.a.array,
        actions: s.a.array,
        className: s.a.string,
        title: s.a.string,
        label: s.a.string.isRequired,
        checked: s.a.bool,
        expanded: s.a.bool
      }).isRequired,
      onNodeToggle: s.a.func,
      onAction: s.a.func,
      onCheckboxChange: s.a.func
    }, t.a = _;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    var a = n(1),
        c = n.n(a),
        u = n(2),
        s = n.n(u),
        f = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        l = function (e) {
      function t() {
        var e, n, i, a;
        r(this, t);

        for (var c = arguments.length, u = Array(c), s = 0; s < c; s++) {
          u[s] = arguments[s];
        }

        return n = i = o(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(u))), i.onClick = function (e) {
          "function" == typeof i.props.onAction && i.props.onAction(i.props.actionData);
        }, a = n, o(i, a);
      }

      return i(t, e), f(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.title,
              n = e.className,
              r = e.text;
          return c.a.createElement("i", {
            title: t,
            className: n,
            onClick: this.onClick
          }, r);
        }
      }]), t;
    }(a.Component);

    l.propTypes = {
      title: s.a.string,
      text: s.a.string,
      className: s.a.string,
      actionData: s.a.object,
      onAction: s.a.func
    }, t.a = l;
  }, function (e, t) {}, function (e, t, n) {
    "use strict";

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    var a = n(1),
        c = n.n(a),
        u = n(2),
        s = n.n(u),
        f = n(7),
        l = n.n(f),
        p = n(138),
        d = n.n(p),
        h = n(142),
        y = n(144),
        v = n.n(y),
        b = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        g = l.a.bind(v.a),
        m = function (e) {
      function t(e) {
        r(this, t);
        var n = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
        return n.onInputChange = function (e) {
          e.persist(), n.delayedCallback(e);
        }, n.delayedCallback = d()(function (e) {
          n.props.onInputChange(e.target.value);
        }, 50, {
          leading: !0
        }), n;
      }

      return i(t, e), b(t, [{
        key: "getTags",
        value: function value() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
              t = arguments[1];
          return e.map(function (e, n) {
            var r = e._id,
                o = e.label,
                i = e.tagClassName;
            return c.a.createElement("li", {
              className: g("tag-item", i),
              key: "tag-" + n
            }, c.a.createElement(h.a, {
              label: o,
              id: r,
              onDelete: t
            }));
          });
        }
      }, {
        key: "render",
        value: function value() {
          return c.a.createElement("span", null, c.a.createElement("ul", {
            className: g("tag-list")
          }, this.getTags(this.props.tags, this.props.onTagRemove), c.a.createElement("li", {
            className: g("tag-item")
          }, c.a.createElement("input", {
            type: "text",
            ref: this.props.inputRef,
            placeholder: this.props.placeholderText || "Choose...",
            onChange: this.onInputChange,
            onFocus: this.props.onFocus,
            onBlur: this.props.onBlur
          }))));
        }
      }]), t;
    }(a.Component);

    m.propTypes = {
      tags: s.a.array,
      value: s.a.string,
      placeholderText: s.a.string,
      onInputChange: s.a.func,
      onFocus: s.a.func,
      onBlur: s.a.func,
      onTagRemove: s.a.func,
      inputRef: s.a.func
    }, t.a = m;
  }, function (e, t, n) {
    function r(e, t, n) {
      function r(t) {
        var n = g,
            r = m;
        return g = m = void 0, O = t, w = e.apply(r, n);
      }

      function f(e) {
        return O = e, j = setTimeout(d, t), k ? r(e) : w;
      }

      function l(e) {
        var n = e - x,
            r = e - O,
            o = t - n;
        return T ? s(o, _ - r) : o;
      }

      function p(e) {
        var n = e - x,
            r = e - O;
        return void 0 === x || n >= t || n < 0 || T && r >= _;
      }

      function d() {
        var e = i();
        if (p(e)) return h(e);
        j = setTimeout(d, l(e));
      }

      function h(e) {
        return j = void 0, E && g ? r(e) : (g = m = void 0, w);
      }

      function y() {
        void 0 !== j && clearTimeout(j), O = 0, g = x = m = j = void 0;
      }

      function v() {
        return void 0 === j ? w : h(i());
      }

      function b() {
        var e = i(),
            n = p(e);

        if (g = arguments, m = this, x = e, n) {
          if (void 0 === j) return f(x);
          if (T) return j = setTimeout(d, t), r(x);
        }

        return void 0 === j && (j = setTimeout(d, t)), w;
      }

      var g,
          m,
          _,
          w,
          j,
          x,
          O = 0,
          k = !1,
          T = !1,
          E = !0;

      if ("function" != typeof e) throw new TypeError(c);
      return t = a(t) || 0, o(n) && (k = !!n.leading, T = "maxWait" in n, _ = T ? u(a(n.maxWait) || 0, t) : _, E = "trailing" in n ? !!n.trailing : E), b.cancel = y, b.flush = v, b;
    }

    var o = n(4),
        i = n(139),
        a = n(140),
        c = "Expected a function",
        u = Math.max,
        s = Math.min;
    e.exports = r;
  }, function (e, t, n) {
    var r = n(0),
        o = function o() {
      return r.Date.now();
    };

    e.exports = o;
  }, function (e, t, n) {
    function r(e) {
      if ("number" == typeof e) return e;
      if (i(e)) return a;

      if (o(e)) {
        var t = "function" == typeof e.valueOf ? e.valueOf() : e;
        e = o(t) ? t + "" : t;
      }

      if ("string" != typeof e) return 0 === e ? e : +e;
      e = e.replace(c, "");
      var n = s.test(e);
      return n || f.test(e) ? l(e.slice(2), n ? 2 : 8) : u.test(e) ? a : +e;
    }

    var o = n(4),
        i = n(141),
        a = NaN,
        c = /^\s+|\s+$/g,
        u = /^[-+]0x[0-9a-f]+$/i,
        s = /^0b[01]+$/i,
        f = /^0o[0-7]+$/i,
        l = parseInt;
    e.exports = r;
  }, function (e, t, n) {
    function r(e) {
      return "symbol" == typeof e || i(e) && o(e) == a;
    }

    var o = n(6),
        i = n(9),
        a = "[object Symbol]";
    e.exports = r;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    var a = n(1),
        c = n.n(a),
        u = n(2),
        s = n.n(u),
        f = n(7),
        l = n.n(f),
        p = n(143),
        d = n.n(p),
        h = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        y = l.a.bind(d.a),
        v = function (e) {
      function t() {
        var e, n, i, a;
        r(this, t);

        for (var c = arguments.length, u = Array(c), s = 0; s < c; s++) {
          u[s] = arguments[s];
        }

        return n = i = o(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(u))), i.onClick = function (e) {
          e.stopPropagation(), i.props.onDelete(i.props.id);
        }, a = n, o(i, a);
      }

      return i(t, e), h(t, [{
        key: "render",
        value: function value() {
          return c.a.createElement("button", {
            onClick: this.onClick,
            className: y("tag-remove"),
            type: "button"
          }, "x");
        }
      }]), t;
    }(a.Component);

    v.propTypes = {
      id: s.a.string.isRequired,
      onDelete: s.a.func
    };

    var b = function (e) {
      function t() {
        return r(this, t), o(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return i(t, e), h(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.id,
              n = e.label,
              r = e.onDelete;
          return c.a.createElement("span", {
            className: y("tag")
          }, n, c.a.createElement(v, {
            id: t,
            onDelete: r
          }));
        }
      }]), t;
    }(a.Component);

    b.propTypes = {
      id: s.a.string.isRequired,
      label: s.a.string.isRequired,
      onDelete: s.a.func
    }, t.a = b;
  }, function (e, t) {}, function (e, t) {}, function (e, t) {}]);
});